import styled from 'styled-components';
import { Container } from '../style';

export const Date = styled.div`
  color: ${({ theme }) => theme.colors.date};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
`;

export const Label = styled.div`
  background-color: ${({ theme }) => theme.colors.focusSelect};
  color: ${({ theme }) => theme.colors.white};
  padding: 0px 12px;
  border-radius: 9px !important;
  position: absolute;
  top: 12px;
  left: 12px;
`;

export const Bottom = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(100% - 173px);
  padding: 14px 10px 20px;

  @media ${(props) => props.theme.device.tablet} {
    padding: 14px 16px 24px;
  }

  & .card-details {
    margin-top: auto;
    margin-left: auto;
  }
`;

export const CardNewsContainer = styled(Container)`
  padding: 0 !important;

  &.news {
    gap: 0 !important;

    .news.title {
      margin-bottom: 8px;
    }
    .description {
      margin-bottom: 20px;
      @media ${(props) => props.theme.device.tablet} {
        margin-bottom: 32px;
      }
    }
    .primary {
      width: 100%;
    }

    &:not(.large) {
      @media ${(props) => props.theme.device.tablet} {
        width: 100%;
      }

      .tertiary {
        margin-right: 10px;
      }
    }

    .card-cover {
      height: 173px !important;
    }

    &.large {
      .card-cover {
        height: 100% !important;
        max-width: 315px;
        min-width: 315px;
      }
      .bottom {
        padding: 10px 36px 22px 29px;
      }
    }
  }
`;
